import PropTypes from 'prop-types';

const GalleryButton = ({ children, className, onClick, right, yCentered }) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      absolute
      bg-black
      bg-opacity-40
      w-14
      h-14
      md:w-20
      md:h-20
      ${className}
      ${right ? 'right-0' : ''}
      ${yCentered ? 'top-1/2 transform -translate-y-2/4' : ''}
    `}
  >
    {children}
  </button>
);

GalleryButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  right: PropTypes.bool,
  yCentered: PropTypes.bool,
};

GalleryButton.defaultProps = {
  className: '',
  onClick: null,
  right: false,
  yCentered: false,
};

export default GalleryButton;
